export default __webpack_public_path__ + "static/media/JeffOptimized.44775053.jp2";